import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import PAYMENT_METHODS from "../../dictionaries/paymentMethods.json";

const paymentMethodOptions = Object.values(PAYMENT_METHODS).map((pM) => (
  <MenuItem key={`PaymentMethod-${pM.id}`} value={pM.id}>
    {pM.name}
  </MenuItem>
));

const PaymentMethodSelectBox = ({ onChange, value, ...props }) => (
  <TextField
    fullWidth
    label="Payment Method"
    onChange={onChange}
    select
    value={value}
    {...props}
  >
    {paymentMethodOptions}
  </TextField>
);

export default PaymentMethodSelectBox;
